import React, { Component } from "react";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { ItemBackgroundCarousel } from "./components";
import { DivHeaderActions } from "./styled";

const defaultItemProps = {
  backgroundColorParent: "rgba(255,255,255,0)",
  backgroundColor: "rgba(255,255,255,0)",
  backgroundImage: {
    url: "",
    urlMobile: "",
    desktop: {
      width: 0,
      height: 0
    },
    mobile: {
      width: 0,
      height: 0
    }
  },
  bgProps: {
    size: "cover",
    position: "center",
    repeat: "no-repeat",
    ratio: 1.2
  },
  isBackgroundImage: false,
  padding: "0px",
  width: {
    type: "%",
    contentWidth: 100
  },
  alignment: {
    vertical: "center",
    horizontal: "center"
  }
};

class ContentCarousel extends Component {
  constructor(props) {
    super(props);
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      width,
      alignment,
      padding,
      backgroundColorParent
    } = props.data.values;

    const bi = backgroundImage
      ? backgroundImage
      : defaultItemProps.backgroundImage;
    const alignContent = alignment ? alignment : defaultItemProps.alignment;
    const bgProperties = bgProps ? bgProps : defaultItemProps.bgProps;
    const isBGI = isBackgroundImage ? isBackgroundImage : false;
    this.state = {
      expandedContent: true,
      backgroundColor: backgroundColor,
      backgroundImage: bi,
      backgroundColorParent: backgroundColorParent,
      isBackgroundImage: isBGI,
      align: alignContent,
      bgProps: bgProperties,
      containerPadding: padding,
      width: width
    };
    this.onClickPaste = this.onClickPaste.bind(this);
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  handleExpandChangeContent = expanded => {
    this.setState({ expandedContent: expanded });
  };
  onClickCopy = () => {
    let newData = this.props.data;

    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.backgroundColorParent = this.state.backgroundColorParent;
    newData.values.padding = this.state.containerPadding;
    newData.values.alignment = this.state.align;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.isBackgroundImage = this.state.isBackgroundImage;
    newData.values.bgProps = this.state.bgProps;
    newData.values.width = this.state.width;
    localStorage.setItem("ContentCarousel", JSON.stringify(newData));
  };
  onClickPaste = () => {
    const contentCarousel = JSON.parse(localStorage.getItem("ContentCarousel"));
    if (contentCarousel) {
      const { values } = contentCarousel;
      this.setState({
        backgroundColor: values.backgroundColor,
        backgroundImage: values.backgroundImage,
        backgroundColorParent: values.backgroundColorParent,
        isBackgroundImage: values.isBackgroundImage,
        align: values.alignment,
        bgProps: values.bgProps,
        containerPadding: values.padding,
        width: values.width
      });
    }
  };
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.backgroundColorParent = this.state.backgroundColorParent;
    newData.values.padding = this.state.containerPadding;
    newData.values.alignment = this.state.align;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.isBackgroundImage = this.state.isBackgroundImage;
    newData.values.bgProps = this.state.bgProps;
    newData.values.width = this.state.width;
    this.props.onUpdateData(newData);
  };

  updateBackgroundContent = values => {
    if (values) {
      this.setState({
        backgroundColor: values.backgroundColor,
        backgroundImage: values.backgroundImage,
        backgroundColorParent: values.backgroundColorParent,
        isBackgroundImage: values.isBackgroundImage,
        align: values.alignment,
        bgProps: values.bgProps,
        containerPadding: values.padding,
        width: values.width
      });
    }
  };

  render() {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      width,
      align,
      containerPadding,
      backgroundColorParent
    } = this.state;
    return (
      <div style={{ width: "100%" }}>
        <div style={{ overflowY: "scroll", height: 500 }}>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expandedContent}
              onExpandChange={expanded =>
                this.handleExpandChangeContent(expanded)
              }
            >
              <CardHeader
                title={`Properties of Content  1`}
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <ItemBackgroundCarousel
                  backgroundColorParent={backgroundColorParent}
                  padding={containerPadding}
                  alignment={align}
                  width={width}
                  backgroundColor={backgroundColor}
                  backgroundImage={backgroundImage}
                  isBackgroundImage={isBackgroundImage}
                  bgProps={bgProps}
                  updateBackground={values =>
                    this.updateBackgroundContent(values)
                  }
                  title={`Content 1`}
                />
              </CardText>
            </Card>
          </div>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  radioButton: {
    width: 100
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
    marginBottom: 10
  }
};

ContentCarousel.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

ContentCarousel.defaultProps = {
  data: {}
};
export default ContentCarousel;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/ContentCarousel.js